import React, { createContext, useState } from 'react';
const GlobalContext = createContext();
export const GlobalProvider = ({ children }) => {
  // const [globalValue, setGlobalValue] = useState('http://127.0.0.1:8000');
  const [globalValue, setGlobalValue] = useState('https://jals.co.in/prod-api');
  // const [globalValue, setGlobalValue] = useState('http://educer.in/jals-api');

  // const [globalValue, setGlobalValue] = useState('https://dceconnect.in/jals_test_api');
  return (
    <GlobalContext.Provider value={{ globalValue, setGlobalValue }}>
      {children}
    </GlobalContext.Provider>
  );
};
export default GlobalContext;
